import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { ContentDetailSection, DetailEditButton } from '~src/app/content/contentDetailDialog/ContentDetailSection';
import { MapDispatchToProps } from '~src/app/utils/ConnectUtils';
import { Messages } from '~src/codegen/Localize';
import { cssClass } from '~src/style';
import { setTabs } from '~src/workbook/actions/SetTabsWorkbookAction';
import { IWorkbookDetailInfoWithUsage } from '~src/workbook/models/IWorkbookInfo';


interface TabbedViewsDetailSectionOwnProps {
  readonly workbook: IWorkbookDetailInfoWithUsage;
  readonly isActionEnabled: boolean;
}

interface TabbedViewsContentDispatchProps {
  readonly setDisplayTabs: (items: IWorkbookDetailInfoWithUsage[]) => void;
}

export type TabbedViewsDetailSectionProps = TabbedViewsDetailSectionOwnProps & TabbedViewsContentDispatchProps;

export function TabbedViewsDetailSection(props: TabbedViewsDetailSectionProps): JSX.Element {
  return (
    <ContentDetailSection
      header={Messages.column_tabs()}
      detail={<TabbedViewsDescription displayTabs={props.workbook.displayTabs} />}
      testId={'tabbed-views'}
      isActionAllowed={props.isActionEnabled}
      action={<DetailEditButton
          buttonLabel={Messages.editTabbedViews_action()}
          buttonTestId={'edit-tabbed-views'}
          onClickAction={() => props.setDisplayTabs([props.workbook])}
        />
      }
    />
  );
}

function TabbedViewsDescription(props: { displayTabs: boolean }): JSX.Element {
  return (<>
    <p className={descriptionText}>{props.displayTabs ? Messages.showTabsValue() : Messages.hideTabsValue()}</p>
    <p className={descriptionText}>{props.displayTabs ? Messages.showTabsDescription() : Messages.hideTabsDescription()}</p>
  </>);
}

const descriptionText = cssClass('content-detail-section','description', {
  marginBlockStart: '0px',
  marginBlockEnd: '0px'
});

const mapDispatchToProps: MapDispatchToProps<TabbedViewsContentDispatchProps> = (dispatch) => bindActionCreators({
  setDisplayTabs: setTabs,
}, dispatch);

export const ConnectedTabbedViewsDetailSection: React.ComponentClass<TabbedViewsDetailSectionOwnProps> =
  connect(undefined, mapDispatchToProps)(TabbedViewsDetailSection);
